module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_9006.342ded32.png";